export default {
  title: {
    text: "中国光刻胶需求量,产量及均价",
    left: "center",
  },
  grid: {
    top: 110,
  },
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      crossStyle: {
        color: "#999",
      },
    },
  },
  toolbox: {
    feature: {
      dataView: {
        show: false,
        readOnly: false,
      },
      magicType: {
        show: false,
        type: ["line", "bar"],
      },
      restore: {
        show: false,
      },
    },
  },
  legend: {
    orient: "horizontal",
    left: "center",
    top: 50,
    data: ["光刻胶需求量", "光刻胶本土产量", "光刻胶均价"],
  },
  xAxis: [
    {
      type: "category",
      data: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
      axisPointer: {
        type: "shadow",
      },
      axisLabel: {
        textStyle: {},
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "万吨",
      min: 0,
      max: 10,
      interval: 2,
      axisLabel: {
        formatter: "{value}",
      },
    },
    {
      type: "value",
      name: "万元/吨",
      min: 5,
      max: 10,
      interval: 1,
      axisLabel: {
        formatter: "{value} ",
      },
    },
  ],
  series: [
    {
      name: "光刻胶需求量",
      type: "bar",
      data: [
        3.4015346,
        3.938619,
        5.370844,
        6.624041,
        7.5191817,
        7.5191817,
        7.877238,
        8.235294,
      ],
    },

    {
      name: "光刻胶本土产量",
      type: "bar",
      data: [
        2.2692308,
        2.3076923,
        2.4423077,
        2.8076923,
        3.2692308,
        3.7692308,
        4.423077,
        4.9038463,
      ],
    },
    {
      name: "光刻胶均价",
      type: "line",
      yAxisIndex: 1,
      data: [
        8.688946,
        8.200514,
        7.197943,
        6.88946,
        6.940874,
        7.0437016,
        7.377892,
        7.429306,
      ],
    },
  ],
};
